import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class ButtonComponent {
  @Input() label: string = 'Button';       
  @Input() type: string = 'button';        
  @Input() outlined: boolean = false;      
  @Input() icon: string = '';              
  @Input() iconPos: any = 'left';       
  @Input() customClass: string = '';       
  @Output() click = new EventEmitter<void>();

  onClick() {
    this.click.emit();  
  }
}
